/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import { getScaledValue } from '../../../ui/styled';

export const SettingsContent = styled.TouchableOpacity.attrs({})`
  width: ${getScaledValue(42)}px;
  height: ${getScaledValue(42)}px;
  border-radius: ${getScaledValue(21)}px;
  align-items: center;
  justify-content: center;
  margintop: ${getScaledValue(10)}px;
  border-width: ${getScaledValue(3)}px;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            border-color: ${props.theme.primary || 'rgba(255,255,255,.1)'};
            background: ${props.theme.primary || 'rgba(255,255,255,.1)'};
        `
      : `
            border-color: rgba(255,255,255,.1);
            background: transparent;
        `}
`;

export const SettingsGlyph = styled.Text.attrs({})`
  color: #ffffff;
  fontsize: ${getScaledValue(16)}px;
`;
